import { useEffect, useState } from 'react';
import { toast } from "react-toastify";
import { api } from '../utils';
import axios from "axios";

const initialState = {
    success: false,
    list: { item1: [], item2: [] },
    loading: true
}

export default function useGetSpecificationItemsWithSamples() {
  const cancelToken = axios.CancelToken;
  const source = cancelToken.source();
  const [item, setItem] = useState(initialState);
    	
  useEffect(() => {
    api.postS(`Item/GetSpecItems`, {ItemNumber: '', HasSpec: false, ActiveOnly: true}, source.token)
      .then(
        r => {
        if(r.data.success){
          setItem({success: true, list: r.data.list, loading:false })
        } else {
           toast.error("GetSpecificationItemsWithSamples query returned an error")
        }
      })
      .catch(api.catchHandler);

      return () => {
        source.cancel("axios request cancelled"); 
      }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return item;
}